export const LOADING_STATES = {
  LOADING: 'loading',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
  IDLE: 'idle',
};
